import { LoaderFunctionArgs } from 'react-router-dom'
import { getStats } from '../../action/quizes'

export const quizesLoader = async ( args: LoaderFunctionArgs ) => {

    await getStats()

}